import { cn } from "@/lib/utils";

//

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-md bg-primary/10", className)} {...props} />;
}

//

interface SkeletonTextProps {
  className?: string;
  textHeightPx?: number;
  containerHeightPx?: number;
  width?: number | string;
}

export const SkeletonText: React.FC<SkeletonTextProps> = ({
  className,
  containerHeightPx = 24,
  textHeightPx = 16,
  width,
}) => {
  return (
    <div
      className={cn("flex", className)}
      style={{
        height: `${containerHeightPx}px`,
        width: width ? `${width}${typeof width === "number" ? "px" : ""}` : "100%",
      }}
    >
      <Skeleton className="my-auto h-3 w-full" style={{ height: `${textHeightPx}px` }} />
    </div>
  );
};

export { Skeleton };
